module.exports = __webpack_public_path__ + "img/logo.47e8e678.png";